var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "highcharts-light bar-chart chart-container" },
    [
      _c("highcharts", {
        ref: "chartComponent",
        staticClass: "chart-element",
        attrs: { options: _vm.chartOptions },
      }),
      _vm._v(" "),
      _c("footer", { staticClass: "pagination" }, [
        _c(
          "button",
          {
            attrs: { disabled: _vm.currentPage === 0 },
            on: { click: _vm.prevPage },
          },
          [_c("i", { staticClass: "fa fa-chevron-up" })]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "page-number" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.currentPage + 1) +
              " / " +
              _vm._s(Math.max(1, Math.ceil(_vm.data.length / _vm.pageSize))) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: {
              disabled:
                _vm.currentPage + 1 >=
                Math.ceil(_vm.data.length / _vm.pageSize),
            },
            on: { click: _vm.nextPage },
          },
          [_c("i", { staticClass: "fa fa-chevron-down" })]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }